// libraries
// todo remoe this material ui phone input
import "react-phone-input-2/lib/material.css";
import "./styles.scss";

import { ar } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";

// types
import { IPhoneNumberFormProps } from "../models";
// constants
import { PHONE_NUMBER_REGEX } from "./regex";
// styles
import styles from "./styles.module.scss";

export const PhoneNumberForm = (props: IPhoneNumberFormProps) => {
  const { onChange, value, placeholder, hasError } = props;
  const { t } = useTranslation();
  const wrongNumber = t("lbl_phone_number_form_wrong_number");
  const pattern = RegExp(PHONE_NUMBER_REGEX);
  return (
    <>
      <div dir="ltr" className={styles.inputPhoneDiv}>
        <PhoneInput
          onChange={onChange}
          specialLabel=""
          value={value}
          isValid={(value) => {
            if (value === "+966") {
              hasError && hasError(true);
              return true;
            }
            if (value.match(pattern)) {
              hasError && hasError(true);
              return true;
            }
            hasError && hasError(false);
            return wrongNumber;
          }}
          country="sa"
          onlyCountries={["sa"]}
          localization={ar}
          inputClass={styles.inputPhone}
          buttonClass={styles.flagDropdown}
          placeholder={placeholder}
          countryCodeEditable={false}
        />
      </div>
    </>
  );
};
